module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-available-gray-adac3f.svg";